import { createListenerMiddleware } from '@reduxjs/toolkit';
import { NotificationTypeEnum } from 'Components/designSystem';
import i18n from 'i18next';
import { showToast, ToastOptions } from 'modules/ToastManager';

import { fetchCandidateProfileThunk, updateCandidateProfileThunk } from './candidateProfileSlice';

const candidateProfileMiddleware = createListenerMiddleware();

const SUCCESS_NOTIFICATION_DURATION = 5000;
const ERROR_NOTIFICATION_DURATION = 5000;

candidateProfileMiddleware.startListening({
    actionCreator: updateCandidateProfileThunk.fulfilled,
    effect: async (_, listenerAPI) => {

        const toast: ToastOptions = {
            id: 'updateCandidateProfile',
            type: NotificationTypeEnum.Success,
            description: i18n.t('success.saved', { ns: 'profile' }),
            duration: SUCCESS_NOTIFICATION_DURATION
        };

        listenerAPI.dispatch(showToast({ toast }));
    }
});

candidateProfileMiddleware.startListening({
    actionCreator: updateCandidateProfileThunk.rejected,
    effect: async (_, listenerAPI) => {

        const toast: ToastOptions = {
            id: 'updateCandidateProfile',
            type: NotificationTypeEnum.Error,
            description: i18n.t('error.saveFailed', { ns: 'profile' }),
            duration: ERROR_NOTIFICATION_DURATION
        };

        listenerAPI.dispatch(showToast({ toast }));
    }
});

candidateProfileMiddleware.startListening({
    actionCreator: fetchCandidateProfileThunk.rejected,
    effect: async (_, listenerAPI) => {

        const toast: ToastOptions = {
            id: 'fetchCandidateProfile',
            type: NotificationTypeEnum.Error,
            description: i18n.t('error.loadFailed', { ns: 'profile' }),
            duration: ERROR_NOTIFICATION_DURATION
        };

        listenerAPI.dispatch(showToast({ toast }));
    }
});

export default candidateProfileMiddleware;
